import * as React from 'react';
import { Select } from 'antd';
export const Delivery = (props) => {
    return (React.createElement(Select, { showSearch: true, optionFilterProp: "children", dropdownMatchSelectWidth: false, filterOption: (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0, ...props },
        React.createElement(Select.Option, { value: "Economy" }, "Economy (30)"),
        React.createElement(Select.Option, { value: "Standard" }, "Standard (24)"),
        React.createElement(Select.Option, { value: "Expedite 1" }, "Expedite1 (18)"),
        React.createElement(Select.Option, { value: "Expedite 2" }, "Expedite2 (14)")));
};
